/* eslint-disable react/no-array-index-key */
import { Stack, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';

const useStyles = makeStyles({
  mySwiper: {
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    overflowY: 'visible',
    touchAction: 'pan-y',
    '& .swiper-wrapper': {
      width: '100%',
      height: '100%',
      overflowY: 'visible',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }
  },

  mySwiperSlide: {
    width: '100%',
    height: '100%'
  }
});
const Categories = ({ statusList, currentStatus, onChange }) => {
  const [swiper, setSwiper] = useState(null);
  const classes = useStyles();
  return (
    <Stack
      sx={{
        width: '100%',
        gap: 1,
        mt: '50px',

        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        pl: 2.5
      }}
    >
      <Stack
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        }}
      >
        <Stack
          sx={{
            width: {
              xs: `100%`
            },
            height: 'auto',
            py: 2.5,
            alignItems: 'center'
          }}
        >
          <Swiper
            onSwiper={(swiperInstance) => {
              setSwiper(swiperInstance);
            }}
            spaceBetween={8}
            slidesPerView="auto"
            freeMode
            className={classes?.mySwiper}
            modules={[FreeMode]}
          >
            {statusList &&
              statusList.map((item, idx) => (
                <SwiperSlide
                  className={classes.mySwiperSlide}
                  key={idx}
                  style={{ width: 'auto' }}
                  onClick={() => onChange(item)} // Handle store type click
                >
                  {({ isActive }) => (
                    <Stack
                      sx={{
                        display: 'flex',
                        backgroundColor:
                          currentStatus?.value === item?.value
                            ? '#1B2872'
                            : '#FFFFFF',
                        border:
                          currentStatus?.value === item?.value
                            ? '1px solid #1B2872'
                            : '1px solid #DADBDD',
                        borderRadius: '20px 0px 20px 20px',
                        p: '7px 20px 6px 20px'
                      }}
                    >
                      <Typography
                        sx={{
                          whiteSpace: 'nowrap',
                          fontSize: 14,
                          letterSpacing: '-0.56px',
                          fontWeight: 500,
                          color:
                            currentStatus?.value !== item?.value
                              ? '#DADBDD'
                              : '#FFFFFF'
                        }}
                      >
                        {item?.label}
                      </Typography>
                    </Stack>
                  )}
                </SwiperSlide>
              ))}
          </Swiper>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Categories;
